import React, { useState } from 'react';
import config from './config.js'

const PopupVisualisation = ({ pointsurvolle }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const getIcone = (thematique) => {
        var l = config.contenu.filter(a => a.thematique === thematique);
        if (l.length > 0) {
            return l[0];
        }
        else
            return null;
    }

    const handlePrev = () => {
        setCurrentIndex((prev) => (prev === 0 ? pointsurvolle.length - 1 : prev - 1));
    };

    const handleNext = () => {
        setCurrentIndex((prev) => (prev === pointsurvolle.length - 1 ? 0 : prev + 1));
    };

    if (pointsurvolle && pointsurvolle.length > 0) {
        const point = pointsurvolle[currentIndex];
        let images = require.context('./assets/pictos', true);
        let theme = getIcone(point.thematique);
        let itemImg = theme ? images(`./${theme.picto}`) : null;

        return (
            <div className="popup">
                {pointsurvolle.length > 1 && (
                    <div className="popup-navigation top-right">
                        <button onClick={handlePrev} className="popup-arrow prev">&lt;</button>
                        <span>{currentIndex + 1} / {pointsurvolle.length}</span>
                        <button onClick={handleNext} className="popup-arrow next">&gt;</button>
                    </div>
                )}
                <div className="popup_vis_titre1">
                    {point.photo && point.photo !== "" ?
                        <img className="popup_image" alt={point.titre} src={process.env.PUBLIC_URL + "/images/" + point.photo} />
                        : null
                    }
                    <div>
                        {itemImg && <img src={itemImg} className="popup_picto" alt={point.nom} title={point.nom} />}
                        <div className="popup_titre">{point.nom}</div>
                    </div>
                </div>
                <div className="popup_separation"></div>
                <div className="popup_description">
                    {point.texte}
                </div>
                {point.nb_salle && point.nb_salle !== "" && point.nb_fauteuil && point.nb_fauteuil !== "" ?
                    <>
                        <div className="popup_separation"></div>
                        <div className="popup-adresse">
                            {point.nb_salle && point.nb_salle !== "" ? <div>Nombre de salles: <b>{point.nb_salle}</b></div> : null}
                            {point.nb_fauteuil && point.nb_fauteuil !== "" ? <div>Nombre de fauteuils: <b>{point.nb_fauteuil}</b></div> : null}
                        </div>
                    </>
                    : null
                }
                <div className="popup_separation"></div>
                <div className="popup-adresse">
                    <div><b>Adresse:</b> {point.adresse}, {point.cp}, {point.ville}</div>
                    {point.tel && point.tel !== "" ? <div><b>Téléphone : </b>{point.tel}</div> : null}
                    {point.mail && point.mail !== "" ? <div><b>Email : </b> <a href={`mailto:${point.mail}`}>{point.mail}</a></div> : null}
                    {point.url && point.url !== "" ? <div><b>Site web:</b> <a target="_blank" rel="noreferrer" href={point.url}>{point.url}</a></div> : null}
                </div>
            </div>
        );
    } else {
        return null;
    }
}

export default PopupVisualisation;